import { GcLoader } from '@garmin/components-global';

export default {
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    GcLoader,
  },
  name: 'TabLoader',
  data() {
    return {
      className: 'app__tab-loader',
    };
  },
};
